import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    productListMenuItem:1,
    imgUrl:'https://www.baochengtech.com',
    searchInput:"",
    isSearch:false,
    isGetData:false,
    isGet:false,
    detail_img:''
  },
  getters,
  mutations: {
    
  },
  actions: {
    SET_IMG({state},url){
      state.detail_img = url;
      if (localStorage) {
        localStorage.setItem('IMG', url);
      }
    }
  },
  modules: {
  }
})
